export const noSubLevel: string[] = ["Incorrect Sentences", "Own Sentences"];
export const initialLevelDict = { "Incorrect Sentences": "", "Own Sentences": "" };
export const incorrectSentenceCount = 10;
